export const formatDateTime = (
  value,
  { dateStyle = "short", withTime = true } = {}
) => {
  if (!value) return "";

  const date = new Date(value);

  if (isNaN(date.getTime())) return "";

  const dateOptions =
    dateStyle === "long"
      ? { weekday: "long", year: "numeric", month: "long", day: "numeric" }
      : { weekday: "short", month: "short", day: "numeric" };

  const formattedDate = date.toLocaleDateString("en-US", dateOptions);

  if (!withTime) return formattedDate;

  const formattedTime = date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
  });

  return `${formattedDate} · ${formattedTime}`;
};

export const getTimeInAmPmFormat = (time) => {
  if (!time) return "-";
  const [h, m] = time.split(":").map(Number);
  const period = h >= 12 ? "PM" : "AM";
  const hour = h % 12 || 12;
  return `${hour}:${m.toString().padStart(2, "0")} ${period}`;
};

export const formatDuration = (minutes) => {
  const totalMinutes = Number(minutes);

  if (!totalMinutes || totalMinutes <= 0) return "0 mins";

  const hrs = Math.floor(totalMinutes / 60);
  const mins = totalMinutes % 60;

  if (hrs > 0 && mins > 0) return `${hrs} hr ${mins} mins`;
  if (hrs > 0) return `${hrs} hr`;
  return `${mins} mins`;
};
export const convertTo24Hour = (time12h) => {
  if (!time12h) return "";
  const [time, period] = time12h.split(" ");
  let [hours, minutes] = time.split(":");
  hours = parseInt(hours);

  if (period === "PM" && hours !== 12) {
    hours += 12;
  } else if (period === "AM" && hours === 12) {
    hours = 0;
  }

  return `${hours.toString().padStart(2, "0")}:${minutes}`;
};

export const convertTo12Hour = (time24h) => {
  if (!time24h) return "";
  const [h, m] = time24h.split(":").map(Number);
  const period = h >= 12 ? "PM" : "AM";
  const hour = h % 12 || 12;
  return `${hour.toString().padStart(2, "0")}:${m
    .toString()
    .padStart(2, "0")} ${period}`;
};

export const formatMonthYear = (dateStr) => {
  return new Date(dateStr).toLocaleDateString("en-US", {
    month: "long",
    year: "numeric",
  });
};